import { Snackbar, styled, Typography } from '@mui/material'
import type { SnackbarVariant } from './types'

export const StyledSnackbar = styled(Snackbar, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'backgroundColor' && prop !== 'isSmallScreen',
})<{ variant?: SnackbarVariant; backgroundColor: string; isSmallScreen: boolean }>`
  cursor: 'pointer';
  padding: ${({ theme }) => theme.spacing(1, 1, 1, 2)};
  box-sizing: border-box;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ theme }) => theme.spacing(1)};
  margin-top: var(--ion-safe-area-top);
  width: 100%;
  margin: ${({ theme }) => theme.spacing(0, 2)};
  max-width: ${({ isSmallScreen, theme }) => (isSmallScreen ? 'fill-available' : theme.spacing(50))};
  top: calc(${({ theme }) => theme.spacing(1)} + var(--ion-safe-area-top));
`

export const Description = styled(Typography)`
  padding: ${({ theme }) => theme.spacing(0, 0, 1, 4)};
`

export const TitleRow = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const LeftContent = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`

export const Body = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`
